<template>
  <section class="gallery-section">
    <div class="gallery-section__wrapper">
      <!-- Text Section -->
      <div class="gallery-section__text">
        <h2 class="gallery-section__title">{{ extraBannerTitle }}</h2>
        <p class="gallery-section__description">
          {{ extraBannerDescription }}
        </p>
        <a
          target="_blank"
          href="https://restaurantguru.com/Casa-Muyo-Barcelona"
          class="font-3"
        >
          {{ extraBannerCta }}</a
        >
      </div>

      <!-- Image Section -->
      <div class="gallery-section__images">
        <img
          v-for="n in 3"
          :key="n"
          :src="require(`../../assets/img/guru/${n}.png`)"
          alt="Guru partners"
          class="gallery-section__image"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "GallerySection",
  computed: {
    extraBannerTitle() {
      return this.getExtraBanner().title;
    },
    extraBannerDescription() {
      return this.getExtraBanner().description;
    },
    extraBannerCta() {
      return this.getExtraBanner().cta;
    }
  },
  methods: {
    getExtraBanner() {
      return this.$store.getters.currentData.extraBanner;
    }
  }
};
</script>

<style scoped>
.gallery-section {
  max-width: 1140px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.gallery-section__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

/* Text section */
.gallery-section__text {
  flex: 1;
  padding-top: 2rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.gallery-section__title {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.gallery-section__description {
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
}

/* Image section */
.gallery-section__images {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.gallery-section__image {
  width: 200px;
  height: 200px;
  object-fit: contain;
}

/* Responsive */
@media (max-width: 768px) {
  .gallery-section__wrapper {
    flex-direction: column;
  }

  .gallery-section__text {
    order: -1;
  }

  .gallery-section__images {
    flex-wrap: wrap;
    justify-content: center;
  }

  .gallery-section__image {
    width: 120px;
    height: 120px;
  }
}
</style>
